import React from 'react';
import SimpleThermalInvoice from './SimpleThermalInvoice';

const SimpleInvoiceExample: React.FC = () => {
  // بيانات تجريبية للفاتورة البسيطة
  const invoiceData = {
    orderNumber: '9028',
    date: 'Wed, May 27, 2020',
    time: '9:27:53 AM',
    taxNumber: '300057772000003',
    phoneNumber: '0570577722',
    paymentMethod: 'الدفع الإلكتروني',
    items: [
      {
        name: 'غير محدود',
        quantity: 1,
        price: 9.0
      },
      {
        name: 'شاورما',
        quantity: 2,
        price: 9.0
      },
      {
        name: 'فول',
        quantity: 2,
        price: 45.0
      }
    ],
    subtotal: 45.0,
    tax: 6.75,
    total: 51.75
  };

  return (
    <SimpleThermalInvoice
      orderNumber={invoiceData.orderNumber}
      date={invoiceData.date}
      time={invoiceData.time}
      taxNumber={invoiceData.taxNumber}
      phoneNumber={invoiceData.phoneNumber}
      paymentMethod={invoiceData.paymentMethod}
      items={invoiceData.items}
      subtotal={invoiceData.subtotal}
      tax={invoiceData.tax}
      total={invoiceData.total}
    />
  );
};

export default SimpleInvoiceExample;
